import { call, put } from 'redux-saga/effects';
import { Action } from 'redux';

import { NotificationActions } from '../actions/NotificationActions';

const SagaHelpers = {
    handleRequest,
};

type Messages = {
    success?: string;
    fail?: string;
    info?: string;
    warning?: string;
};

type Params<T> = {
    request: [any, T];
    actions: [(data: any) => Action, (error: any) => Action];
    messages?: Messages;
    onSuccess?: (response: any, payload: any) => any;
    onFail?: () => any;
    preRequest?: () => any;
};

function* handleRequest<T>({
    request,
    actions,
    messages = {},
    onSuccess,
    onFail,
    preRequest,
}: Params<T>) {
    const [func, payload] = request;
    const [successAction, failAction] = actions;
    const { success, fail, info, warning } = messages;

    try {
        if (preRequest) {
            yield preRequest();
        }

        const response = yield call(func, payload);
        if (onSuccess) {
            yield onSuccess(response, payload);
        }

        yield put(successAction(response.data));

        if (success) {
            yield put(NotificationActions.success(success));
        }
        if (warning) {
            yield put(NotificationActions.warning(warning));
        }
        if (info) {
            yield put(NotificationActions.info(info));
        }
    } catch (error) {
        if (onFail) {
            yield onFail();
        }

        yield put(failAction(error));
        if (error || fail) {
            const err = error as { message?: string; error?: string } | string;
            const message =
                (typeof err === 'string'
                    ? err
                    : err?.message ||
                      (err as { error?: string })?.error ||
                      fail) ?? 'Unknown error';

            yield put(NotificationActions.error(message));
        }
    }
}

export default SagaHelpers;
